import { React, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { FreeMode, Pagination, Navigation } from "swiper";
import { Link } from "react-router-dom";
import { SVGIcons, ImgIcons, Imgbanner } from "../../Helpers/Common";
import { Showdetailspopup } from "../Showdetailspopup/Showdetailspopup";
import Hover from "../OnHoverDetails/Hover";

var SVGIcon = "";
SVGIcons().then((resultData) => (SVGIcon = resultData));

export function Layout11(props) {
  const [showdetails, setshowdetails] = useState(false);
  const [details, setdetails] = useState(false);

  function showdetailspop(data) {
    setshowdetails(true);
    setdetails(data);
  }

  let Closepopup = () => {
    setshowdetails(false);
  };

  return (
    <>
      <section className="mb-0 dD-none">
        <div className="temp16">
          <div className="head">
            <h3>
              {props.title.display_title}
              <span className="red">{props.title.display_title_sufix}</span>
            </h3>
            {props.title.show_more ? (
              <Link to={"baypage/" + props.title.slug}>
                {" "}
                <img src={SVGIcon["right-arrow.svg"]} />{" "}
              </Link>
            ) : null}
          </div>
          <div className="temp16-area">
            <Swiper
              slidesPerView={2.4}
              spaceBetween={16}
              freeMode={true}
              loop={false}
              loopFillGroupWithBlank={true}
              centeredSlides={false}
              breakpoints={{
                650: {
                  slidesPerView: 1,
                },
                700: {
                  slidesPerView: 4,
                },
                820: {
                  slidesPerView: 4,
                },
                850: {
                  slidesPerView: 6.3,
                },
              }}
              modules={[FreeMode, Pagination]}
              className="temp16-slider"
            >
              {props.Layout1.map((data, index) => {
                if (data.keywords) {
                  var keyword = data.keywords.split(",");
                  keyword = keyword[0];
                } else {
                  var keyword = "";
                }

                return (
                  <SwiperSlide className="temp16-item" key={index}>
                    <div
                      onClick={() => {
                        showdetailspop(data);
                      }}
                    >
                      <div className="temp16-itemColor">
                        <img src={data.thumbnail_image2.medium} />
                      </div>
                      <div className="bay-title">{keyword}</div>
                      <div className="premium-red"> </div>
                    </div>
                  </SwiperSlide>
                );
              })}
              <SwiperSlide> </SwiperSlide>
            </Swiper>
          </div>
        </div>
      </section>
      <section className="mb-0 dD-block">
        <div className="temp16">
          <div className="head-layout">
            <h3>
              {props.title.display_title}
              <span className="red">{props.title.display_title_sufix}</span>
            </h3>
            <div className="arrow-layout">
              {props.title.show_more ? (
                <Link to={"/baypage/" + props.title.slug}>
                  <div className="hoverText">View All</div>
                </Link>
              ) : null}
              <div className="arrow-icon">
                {props.title.show_more ? (
                  <Link to={"/baypage/" + props.title.slug}>
                    <img src={SVGIcon["right-arrow.svg"]} />
                  </Link>
                ) : null}
              </div>
            </div>
          </div>
          <div className="temp16-area">
            <Swiper
              navigation={{
                prevEl: ".slick-prev",
                nextEl: ".slick-next",
              }}
              slidesPerView={2.4}
              spaceBetween={16}
              freeMode={true}
              loop={false}
              slidesPerGroup={6}
              loopFillGroupWithBlank={true}
              centeredSlides={false}
              breakpoints={{
                650: {
                  slidesPerView: 1,
                },
                850: {
                  slidesPerView: 6.3,
                },
              }}
              modules={[Navigation, FreeMode, Pagination]}
              className="temp16-slider"
            >
              <div className="side-overlay-L dD-block"></div>
              <button
                className="slick-prev slick-arrow"
                type="button"
                aria-label="Previous"
              />
              {props.Layout1.map((data, index) => {
                if (data.keywords) {
                  var keyword = data.keywords.split(",");
                  keyword = keyword[0];
                } else {
                  var keyword = "";
                }
                return (
                  <SwiperSlide className="temp16-item" key={index}>
                    <Hover
                      data={data}
                      silverIcon={props.silverIcon}
                      goldenIcon={props.goldenIcon}
                    />
                    <div className="temp16-itemColor">
                      <img src={data.thumbnail_image2.medium} />
                    </div>
                    <div className="bay-title">{keyword}</div>
                    <div className="premium-red"> </div>
                  </SwiperSlide>
                );
              })}
              <SwiperSlide> </SwiperSlide>
              <div className="side-overlay-R dD-block"></div>
              <button
                className="slick-next slick-arrow"
                type="button"
                aria-label="Next"
              />
            </Swiper>
          </div>
        </div>
      </section>
      {showdetails ? (
        <Showdetailspopup
          data={details}
          Closebtn={Closepopup}
          silverIcon={props.silverIcon}
          goldenIcon={props.goldenIcon}
        />
      ) : null}
    </>
  );
}

export default Layout11;
